<template>
  <div>
    <div v-if="storeState.editableDetails.comments.length === 0">
      <span>
        <span class="light-grey">Comments</span>          
        <v-tooltip right dark color="#333">
          <template v-slot:activator="{ on }">
            <span v-on="on" class="add-comment">
              <v-btn @click="addComment" x-small text icon>
                <v-icon>mdi-plus</v-icon>
              </v-btn>  
            </span>
          </template>
          <span>Add comment
            <span class="key">
              <span class="key-inner">M</span>
            </span>
          </span>
        </v-tooltip>
      </span>
    </div>
    <div v-else v-for="(comment, index) in storeState.editableDetails.comments" :key="index">
      <v-card flat class="pa-0">
        <v-card-text class="pl-0 comment-text">
          <v-hover
            v-slot:default="{ hover }"
            :open-delay="0"
            :close-delay="0"
            :disabled="false"
            :value="hov"
          >
            <v-textarea
              v-on:keydown.enter="handleCmdEnter($event, comment)"
              v-model="storeState.editableDetails.comments[index].text"
              no-resize
              :disabled="comment.disabled"
              :readonly="comment.disabled"
              outlined
              name="input-7-1"
              :value="comment.text"
              :id="comment.uid"
              :ref="comment.uid"
              :autofocus="comment.autofocus"
            >
              <template v-slot:label>
                <v-avatar size="24">
                  <img :src="storeState.settings.user.me.pic">
                </v-avatar>
                <span class="ml-2">{{storeState.settings.user.me.email.split('@')[0]}}</span>
                <span class="ml-2 comment-time red--text">{{1568851200000 | dateFilter}}</span>
              </template>
              <template v-slot:append>
                <v-btn icon small :disabled="false" v-if="comment.disabled && hover" @click="editComment(comment, $event)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon small :disabled="false" v-else-if="!comment.disabled" @click="saveComment(comment, $event)">
                  <v-icon>mdi-check</v-icon>
                </v-btn>
              </template>
            </v-textarea>
          </v-hover>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { store } from '../store.js';


export default {
  props: ['text', 'name'],
  created() {
    // this.getUserData()
    // this.getFoodFacts();
    // this.renderUserEntries();
  },
  methods: {
    editComment(comment, e) {
      console.log('edit...', comment)
      this.storeState.currentFocus = 'editingComment'
      comment.disabled = false;
      this.storeState.editingComment = comment
    },
    saveComment(comment, e) {
      console.log('save...', comment)
      this.storeState.currentFocus = 'details'
      comment.disabled = true;
    },
    handleCmdEnter(e, comment) {
      console.log('handleCmdEnter: ', e)
      if (e.metaKey || e.ctrlKey) {
        this.saveComment(comment, e)
      }
    },
    addComment() {
      let uid = `comment_${(Math.random()*1000000000000000000).toString()}`
      let c = {
        text: '', 
        title: 'This title', 
        user: 'Mike', 
        autofocus: true, 
        uid: uid,
        disabled: false
      };
      this.storeState.cmdkActive = false;
      this.storeState.editableDetails.comments.push(c);
    },
  },
  mounted() {
  },
  filters: {
    dateFilter: function (date) {
      return moment(Number(date)).fromNow();
    }
  },
  data() {
    return {
      storeState: store.state,
      hov: false,
    }
  }
};
</script>

<style>
.add-comment {
  margin-left: 10px;
}
.light-grey {
  color: rgba(0, 0, 0, 0.54);
}
</style> 